import { render, staticRenderFns } from "./EventAlert.vue?vue&type=template&id=359e74ee&scoped=true&"
import script from "./EventAlert.vue?vue&type=script&lang=js&"
export * from "./EventAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e74ee",
  null
  
)

export default component.exports